import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import type { PopupStore } from '@gem/popups';
import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { IWorkspaceUser } from 'APP/Tasks/workspace/getWorkspaceUsers';
import { MyProfilePopup } from 'APP/main/PopupManager/Popups/MyProfilePopup/MyProfilePopup';
import { UserProfilePopup } from 'APP/main/PopupManager/Popups/UserProfilePopup/UserProfilePopup';

export interface IWorkspaceMembersPopupPresenter {
  searchText: string;
  childPopup: PopupStore | null;
  hasBackButton: boolean;
  onSearch(searchText: string): void;
  onClose(): void;
  onBack(): void;
  onMemberClick(member: IWorkspaceUser): Promise<void>;
}

export function useWorkspaceMembersPopupPresenter({
  onClose,
  onBack,
  popupInstance,
}: ICommonPopupsProps): IWorkspaceMembersPopupPresenter {
  const presenter = useLocalObservable<IWorkspaceMembersPopupPresenter>(() => ({
    searchText: '',
    childPopup: null,

    get hasBackButton(): boolean {
      return !!onBack;
    },

    onSearch(searchText: string): void {
      this.searchText = searchText;
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },

    async onMemberClick(member: IWorkspaceUser): Promise<void> {
      popupInstance?.hide();
      const onBack = (): void => popupInstance?.show();

      this.childPopup = member.user.isMe
        ? Tasks.app.openPopup(MyProfilePopup, {
            onBack,
            params: { hasBackButton: true },
          })
        : Tasks.app.openPopup(UserProfilePopup, {
            onClose: (): void => popupInstance?.close(),
            onBack,
            params: { userId: member.user.id, hasBackButton: true },
          });
    },
  }));

  useEffect(() => {
    return () => presenter.childPopup?.close();
  }, []);

  return presenter;
}
